import { useLayoutEffect, useRef, useState } from 'react';

const useElementDimension = <T extends HTMLElement>() => {
  const ref = useRef<T>(null);
  const [dimension, setDimension] = useState<DOMRectReadOnly | undefined>();
  useLayoutEffect(() => {
    if (!ref.current || !window.ResizeObserver) {
      // Ignore if `ResizeObserver` not available in the browser. We've had some errors due to Chrome Mobile iOS.
      // By doing this, the component still works, but the content's width is always set to `auto`.
      return;
    }

    const resizeObserver = new ResizeObserver(entries => {
      return setDimension(entries[0]?.contentRect);
    });
    resizeObserver.observe(ref.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return { dimension, ref };
};

export default useElementDimension;
